/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { OVERVIEW } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import { Switch, Popconfirm, message } from 'antd';
import StyledTable from '../../../commons/styles/table';

const CraneManagement = ({ translationCache }) => {
  const [dataSource, setDataSource] = useState([]);
  const [status, setStatus] = useState('');

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = () => {
    let siteId = localStorage.get('currentSite') || 'test';
    const accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'GET',
      url: `${OVERVIEW.GetStatus}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const confirm = (text, row) => {
    row.Status = status === true ? 'Active' : 'Inactive';
    let siteId = localStorage.get('currentSite') || 'test';
    const accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'POST',
      url: `${OVERVIEW.UpdateStatus}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        ...row,
        SiteId: siteId
      }
    };

    axios(headers)
      .then(() => {
        getTableData();
        message.success('Crane Status Updated Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const cancel = () => {
    getTableData();
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const columns = [
    {
      title: translation('CraneName'),
      dataIndex: 'DeviceCode',
      key: 'DeviceCode'
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      render: (text, row) => (
        <Popconfirm
          title="Are you sure to change this status?"
          onConfirm={() => confirm(text, row)}
          onCancel={cancel}
          okText="Yes"
          cancelText="No"
        >
          <Switch
            checkedChildren="Active"
            unCheckedChildren="InActive"
            onChange={(e) => setStatus(e)}
            checked={text === 'Active'}
          />
        </Popconfirm>
      )
    }
  ];

  return (
    <div>
      <StyledTable size="small"
        dataSource={dataSource}
        columns={columns}
        bordered={false}
        pagination={
          dataSource.length > 10
            ? { pageSize: 7 }
            : false
        }
      />
    </div>
  );
};

export default CraneManagement;